import { Capacitor, registerPlugin } from '@capacitor/core';

export const APP_ICON_FEATURE_FLAG = 'alternate-app-icon';
export const APP_ICON_NAMES = {
  default: 'default',
  alternate: 'alternate',
};

const AppIconPlugin = registerPlugin('AppIconPlugin');

async function setAppIcon(icon) {
  if (!Capacitor.isNativePlatform()) {
    return false;
  }

  await AppIconPlugin.setIcon({ icon });
  return true;
}

export async function syncAppIconWithFeatureFlags(isEnabled) {
  const icon = isEnabled(APP_ICON_FEATURE_FLAG) ? APP_ICON_NAMES.alternate : APP_ICON_NAMES.default;

  try {
    await setAppIcon(icon);
  } catch (error) {
    console.warn('[AppIcon] Failed to apply configured app icon:', error?.message);
  }
}
